import React from "react";

export function Card({ title, desc, children, className = "", right }) {
  return (
    <div className={`rounded-2xl border border-white/10 bg-[#121215] p-5 ${className}`}>
      {(title || right) && (
        <div className="flex items-start justify-between mb-4">
          <div>
            {title && <h3 className="font-head font-bold text-lg">{title}</h3>}
            {desc && <p className="text-sm text-zinc-500 mt-0.5">{desc}</p>}
          </div>
          {right}
        </div>
      )}
      {children}
    </div>
  );
}

export function Field({ label, value, onChange, type = "text", placeholder = "", tid, prefix }) {
  return (
    <div>
      {label && <label className="text-xs font-semibold text-zinc-400">{label}</label>}
      <div className={`mt-1 flex items-center rounded-xl bg-white/[0.04] border border-white/10 focus-within:border-[#FF6B00] overflow-hidden`}>
        {prefix && <span className="pl-3 text-sm text-zinc-500">{prefix}</span>}
        <input type={type} value={value ?? ""} placeholder={placeholder} onChange={(e) => onChange(type === "number" ? e.target.value : e.target.value)} data-testid={tid}
          className="w-full bg-transparent px-4 py-2.5 outline-none text-sm" />
      </div>
    </div>
  );
}

export function TextArea({ label, value, onChange, rows = 3, tid, placeholder = "" }) {
  return (
    <div>
      {label && <label className="text-xs font-semibold text-zinc-400">{label}</label>}
      <textarea value={value ?? ""} rows={rows} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} data-testid={tid}
        className="w-full mt-1 rounded-xl bg-white/[0.04] border border-white/10 px-4 py-2.5 outline-none text-sm focus:border-[#FF6B00]" />
    </div>
  );
}

export function Toggle({ checked, onChange, label, tid }) {
  return (
    <button type="button" onClick={() => onChange(!checked)} data-testid={tid} className="flex items-center gap-3">
      <span className={`h-6 w-11 rounded-full transition-colors relative ${checked ? "bg-[#FF6B00]" : "bg-white/15"}`}>
        <span className={`absolute top-0.5 h-5 w-5 rounded-full bg-white transition-all ${checked ? "left-[22px]" : "left-0.5"}`} />
      </span>
      {label && <span className="text-sm">{label}</span>}
    </button>
  );
}

export function SaveBtn({ onClick, loading, children = "Salvar alterações", tid = "save-btn" }) {
  return (
    <button onClick={onClick} disabled={loading} data-testid={tid}
      className="rounded-full hmmm-gradient text-white px-6 py-2.5 font-bold hmmm-glow disabled:opacity-60 active:scale-95 transition-transform">
      {loading ? "Salvando..." : children}
    </button>
  );
}

export function Empty({ children }) {
  return <div className="rounded-2xl border border-dashed border-white/10 py-12 text-center text-sm text-zinc-500">{children}</div>;
}
